module.exports = __webpack_public_path__ + "img/sn-vk-dark.a02a55a9.svg";